import React from 'react';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useStyles } from './styles';
import { Box, Typography } from '@material-ui/core';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useDispatch } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import { createAisle } from '../../store/actions/activateMerchantApp';

const validationSchema = yup.object({
  name: yup
    .string('Enter Device Name')
    .required('Device Name is required'),
});

export default function AddDeviceModal({ handleClose }) {
  const classes = useStyles();
  const tabletView = useMediaQuery('(max-width: 920px');
  const dispatch = useDispatch();
  const route = useRouteMatch();
  const storeId = route.params.storeid;
  const formik = useFormik({
    initialValues: {
      name: '',
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      handleClose();
      await dispatch(createAisle(values, storeId));
    },
  });
  return (
    <div
      className={
        tabletView ? classes.formContainerTabletView : classes.formContainerModal
      }
    >
      <Box className={classes.titleContainer}>
        <Typography className={classes.dialogTitle}>ADD DEVICE</Typography>
      </Box>
      <Box style={{padding: '20px 20px 30px'}}>
      <form onSubmit={formik.handleSubmit}>
        <Box
          className='fieldsContainer'
        >
          <Box style={{ marginTop: '30px' }}>
            <TextField
              fullWidth
              type="text"
              id="name"
              name="name"
              placeholder="Enter Device Name"
              autoComplete='off'
              value={formik.values.name}
              // onChange={formik.handleChange}
              onChange={({target: {value}}) => {
                formik.setFieldValue("name", value.trim() ? value : '')
              }}
              error={
                formik.touched.name && Boolean(formik.errors.name)
              }
              helperText={
                formik.touched.name && formik.errors.name
              }
            />
          </Box>
          <Box style={{ marginTop: '60px' }}>
            <Button color="primary" variant="contained" fullWidth type="submit" disabled={formik.isSubmitting}>
              Submit
            </Button>
          </Box>
        </Box>
      </form>
      </Box>
    </div>
  );
}
